import * as React from 'react';

const CloseIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={10} height={10} fill="none" {...props}>
    <path
      d="M9.434 1.496L6.152 4.777l3.254 3.254a.599.599 0 010 .903.599.599 0 01-.902 0L5.223 5.68 1.969 8.934a.599.599 0 01-.903 0c-.273-.246-.273-.657 0-.93L4.32 4.75 1.066 1.496c-.273-.246-.273-.656 0-.93.246-.246.657-.246.93 0L5.25 3.848 8.504.594c.246-.274.656-.274.93 0a.644.644 0 010 .902z"
      fill="currentColor"
    />
  </svg>
);

export default CloseIcon;
